<p-toast></p-toast>

<app-page-shell>
    <app-page-hero
        eyebrow="Party Management"
        title="Client Organizations"
        subtitle="Manage linked companies, transport agencies, freight forwarders, and shippers.">
        <div actions>
            <p-button label="New Company" icon="pi pi-plus" (click)="createParty('Company')"></p-button>
        </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

    <app-page-data-panel title="Organization Directory" subtitle="Search and maintain organization parties by role.">
        <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange({ index: $event })" styleClass="party-tabs">
            <p-tablist>
                <p-tab [value]="0">
                    <span class="tab-label"><i class="pi pi-building"></i> Companies</span>
                </p-tab>
                <p-tab [value]="1">
                    <span class="tab-label"><i class="pi pi-truck"></i> Transportation Agencies</span>
                </p-tab>
                <p-tab [value]="2">
                    <span class="tab-label"><i class="pi pi-globe"></i> Freight Forwarders</span>
                </p-tab>
                <p-tab [value]="3">
                    <span class="tab-label"><i class="pi pi-box"></i> Shippers</span>
                </p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['Company']" (keyup.enter)="onSearch()"
                                placeholder="Search companies by name, email, phone, or CR" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('Company')" [disabled]="!searchTerms['Company']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('Company')"></p-button>
                        </div>
                    </div>
                    <app-party-table #companyTable
                        [parties]="companies"
                        [totalRecords]="totalCompanies"
                        [isLoading]="isLoading"
                        icon="pi pi-building"
                        emptyMessage="No companies found."
                        [resolveViewLink]="organizationDetailRoute"
                        (lazyLoad)="loadData($event, ['Company'])"
                        (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
                <p-tabpanel [value]="1">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['TransportationAgency']" (keyup.enter)="onSearch()"
                                placeholder="Search agencies by name, email, phone, or CR" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('TransportationAgency')" [disabled]="!searchTerms['TransportationAgency']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('TransportationAgency')"></p-button>
                        </div>
                    </div>
                    <app-party-table #agencyTable
                        [parties]="agencies"
                        [totalRecords]="totalAgencies"
                        [isLoading]="isLoading"
                        icon="pi pi-truck"
                        emptyMessage="No agencies found."
                        [resolveViewLink]="organizationDetailRoute"
                        (lazyLoad)="loadData($event, ['TransportationAgency'])"
                        (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
                <p-tabpanel [value]="2">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['FreightForwarder']" (keyup.enter)="onSearch()"
                                placeholder="Search forwarders by name, email, phone, or CR" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('FreightForwarder')" [disabled]="!searchTerms['FreightForwarder']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('FreightForwarder')"></p-button>
                        </div>
                    </div>
                    <app-party-table #forwarderTable
                        [parties]="forwarders"
                        [totalRecords]="totalForwarders"
                        [isLoading]="isLoading"
                        icon="pi pi-globe"
                        emptyMessage="No freight forwarders found."
                        [resolveViewLink]="organizationDetailRoute"
                        (lazyLoad)="loadData($event, ['FreightForwarder'])"
                        (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
                <p-tabpanel [value]="3">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['Shipper']" (keyup.enter)="onSearch()"
                                placeholder="Search shippers by name, email, phone, or CR" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('Shipper')" [disabled]="!searchTerms['Shipper']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('Shipper')"></p-button>
                        </div>
                    </div>
                    <app-party-table #shipperTable
                        [parties]="shippers"
                        [totalRecords]="totalShippers"
                        [isLoading]="isLoading"
                        icon="pi pi-box"
                        emptyMessage="No shippers found."
                        [resolveViewLink]="organizationDetailRoute"
                        (lazyLoad)="loadData($event, ['Shipper'])"
                        (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </app-page-data-panel>
</app-page-shell>

<app-party-quick-create-dialog
    [visible]="quickCreateVisible"
    [mode]="quickCreateMode"
    [record]="quickCreateRecord"
    [owningCompany]="owningCompany"
    [countries]="countries"
    [titleOverride]="quickCreateTitle"
    [submitLabel]="quickCreateSubmitLabel"
    (visibleChange)="onQuickCreateVisibilityChanged($event)"
    (created)="onQuickCreateCompleted()"
    (failed)="onQuickCreateFailed($event)">
</app-party-quick-create-dialog>

<p-dialog
    header="Find Existing Company"
    [(visible)]="companyLookupVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(32rem, 92vw)' }"
    (onHide)="closeCompanyLookup()">
    <div class="lookup-dialog-body">
        <p class="lookup-dialog-copy">
            Enter the CR number first. If the company already exists, it will be linked immediately. If not, the company create dialog will open with the CR number filled in.
        </p>
        <label class="lookup-dialog-label" for="companyLookupCrNumber">CR Number</label>
        <input
            id="companyLookupCrNumber"
            pInputText
            [(ngModel)]="companyLookupCrNumber"
            (keyup.enter)="submitCompanyLookup()"
            placeholder="Enter CR number" />
    </div>
    <ng-template pTemplate="footer">
        <div class="lookup-dialog-footer">
            <p-button label="Cancel" severity="secondary" [outlined]="true" (click)="closeCompanyLookup()"></p-button>
            <p-button
                label="Continue"
                icon="pi pi-arrow-right"
                [loading]="companyLookupSubmitting"
                [disabled]="!companyLookupCrNumber.trim()"
                (click)="submitCompanyLookup()"></p-button>
        </div>
    </ng-template>
</p-dialog>
